import $ from 'jquery';

export default function perksMessaging() {
    $.get('/api/shoppingcart/getcartitemsinfo').done(function(result) {
        var $warning = $('#SmartPerksFreeWarningMessage'),
            $message = $('.SmartPerksFreeMessageShared'),
            PERKSMIN = 75;

        if (result.Content.CartContainsOnlyAddOnItems && result.Content.CartSubTotal < PERKSMIN) {
            $warning.removeClass('jsHide');
            $message.addClass('jsHide');
        } else {
            $message.removeClass('jsHide');
            $warning.addClass('jsHide');
        }
    });
}


